import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import TextInputField from "../TextInputs/TextInputField";
import CloseButton from "../Buttons/CloseButton";
import ActionButton from "../Buttons/ActionButton";
import { normalizeHref } from "../../../api_calls/announcementUtils";

const AnnouncementLinkDialog = ({ open, url, text, onClose, onApply }) => {
  const [linkUrl, setLinkUrl] = React.useState(url || "");
  const [displayText, setDisplayText] = React.useState(text || "");
  const [errors, setErrors] = React.useState({});

  React.useEffect(() => {
    if (open) {
      setLinkUrl(url || "");
      setDisplayText(text || "");
      setErrors({});
    }
  }, [open, url, text]);

  const applyLink = () => {
    const nextErrors = {};
    const href = normalizeHref(linkUrl);
    if (href === "") {
      nextErrors.url = "URL must not be empty.";
    }
    if (String(displayText || "").trim() === "") {
      nextErrors.text = "Display text must not be empty.";
    }
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    onApply({
      url: href,
      text: String(displayText).trim(),
    });
  };

  return (
    <Dialog open={open} onClose={(event) => event.preventDefault()} fullWidth maxWidth="sm">
      <DialogTitle>Insert link</DialogTitle>
      <DialogContent>
        <TextInputField
          fieldRequired={true}
          elemId="announcementLinkText"
          label="Display text"
          fieldName="announcement_link_text"
          defaultVal={displayText}
          inputType="text"
          onChangeCall={(event) => setDisplayText(event.target.value)}
          fieldError={errors.text || ""}
        />
        <Box height={8} />
        <TextInputField
          fieldRequired={true}
          elemId="announcementLinkUrl"
          label="URL"
          fieldName="announcement_link_url"
          defaultVal={linkUrl}
          inputType="text"
          onChangeCall={(event) => setLinkUrl(event.target.value)}
          fieldError={errors.url || ""}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2}>
          <CloseButton
            onClick={(event) => {
              event.preventDefault();
              onClose();
            }}
            label="Cancel"
            icon={<Close />}
          />
          <ActionButton
            onClick={(event) => {
              event.preventDefault();
              applyLink();
            }}
            label="Apply"
            icon={<Check />}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementLinkDialog;
